import React, {useState} from "react"
import VisibilitySensor from "react-visibility-sensor"
import Loading from "@irati/ui/src/Loading"

export type onNewPage = (isVisible: boolean) => any

interface Props {
  onNewPage: onNewPage
}

const ShowMore: React.FC<Props> = ({onNewPage}) => {
  const [load, setLoad] = useState(null)

  return (
    <>
      <VisibilitySensor partialVisibility onChange={(isVisible) => setLoad(onNewPage(isVisible))}>
        <div style={{height: 10}} />
      </VisibilitySensor>
      <Loading load={load} />
    </>
  )
}

export default ShowMore
